import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { setStateValue } from '../../../../../../actions/actionsModuloRelatorio';
import * as service from '../../services';
import { useState } from 'react';

export const useGetSavedReport = () => {
  const [savedReportParams, setSavedReportParams] = useState({ page: 0, size: 10, query: '' });
  const dispatch = useDispatch();

  const successAction = async data => {
    dispatch(setStateValue('savedReportData', data.data));
  };

  const handleSavedReportChangePage = page => {
    setSavedReportParams({ page, size: 10, query: '' });
  };

  const handleSavedReportSearch = query => {
    setSavedReportParams({ page: 0, size: 10, query });
  };

  const { isLoading, refetch } = useQuery({
    queryKey: ['get-saved-report-table', savedReportParams],
    queryFn: () => service.getSavedReportListService(savedReportParams),
    onSuccess: successAction,
    retry: false,
  });

  return {
    savedReportIsLoading: isLoading,
    refetchTabelaBase: refetch,
    handleSavedReportChangePage,
    handleSavedReportSearch,
  };
};
